import { useMutation, MutationKey } from "react-query";
import Axios from "axios";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";

export type SaveFleetBlockedUsersPayload = { vehicleId: number; userIds: string[] };

/**
 * Saves blocked user IDs for a vehicle (POST /fleet/vehicles/:vehicleId/blocked-users).
 * Call when updating a vehicle to persist the blocked-users list.
 */
export function useRemoteSaveFleetBlockedUsers() {
  const { t } = useTranslation();
  const snackbar = useSnackbar();

  return useMutation<void, RemoteApiError, SaveFleetBlockedUsersPayload>(
    ["fleet", "save-blocked-users"] as MutationKey,
    async ({ vehicleId, userIds }: SaveFleetBlockedUsersPayload): Promise<void> => {
      try {
        await Axios.post(`/fleet/vehicles/${vehicleId}/blocked-users`, {
          users: userIds.map(userId => ({ userId }))
        });
        snackbar.enqueueSnackbar(t("Blocked users updated"), { variant: "success" });
      } catch (error) {
        snackbar.enqueueSnackbar(t("There was a server error"), { variant: "error" });
        throw error;
      }
    }
  );
}
